var banner = function() {
  var $ = require('jquery');
  require('jquery-unslider');

  if ($(".banner__image").length >= 2) {
    $(".banner").addClass("banner__slider");
    var input = $(".banner__search input");

    var banner = $(".banner");
    banner.unslider({
      autoplay: true,
      infinite: true,
      speed: 1000,
      delay: 6000,
      arrows: false,
      dots: true
    });

    banner.on('mouseover', function() {
        banner.data('unslider').stop();
    }).on('mouseout', function() {
        banner.data('unslider').start();
    });
  }

  if ($(".banner__slider").length) {
    var input = $(".banner__search input");
    input.attr('size', input.attr('placeholder').length);
  }

  $("nav.unslider-nav li").html('<img src="/wp-content/themes/pm-child/images/banner-icon.png">');

}
module.exports = banner;